import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import BackButton from '../components/BackButton'
import { handleRedirect } from '../Script'
import {getCachedData} from '../Firebase'

import { LazyLoadImage } from 'react-lazy-load-image-component';

import 'swiper/css';

export default function Avatars() {
    const { t } = useTranslation();

    const [avatarsList, setAvatarsList] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true)
        // getAvatarsList().then((photos) => {
        //     setAvatarsList(photos)
        //     setIsLoading(false)
        // })
        getCachedData("avatars").then((photos) => {
            setAvatarsList(photos)
            setIsLoading(false)
        })
    }, [])


    return (
        <>
            <div className=' pt-4 ' style={{ marginBottom: "12rem" }} >

                <div className='container' data-aos='fade-down'>
                    <BackButton title="Avatars" />
                </div>




                <div className='container mt-6' >
                    <h1 className='mb-2'>Choose your Avatar</h1>




                    <div className='photo-grid' data-aos='fade-up'>
                        {isLoading ? (
                            // Show skeletons while loading
                            Array(6)
                                .fill(0)
                                .map((_, index) => (
                                    <div key={index} className='skeleton-square'></div>
                                ))
                        ) : avatarsList && avatarsList.length > 0 ? (
                            // Show images when loaded
                            avatarsList.map((photo, index) => (
                                <LazyLoadImage
                                    key={index}
                                    onClick={() => handleRedirect(photo, 'avatar')}
                                    src={photo.preview_image_url}
                                    alt={`Photo ${index}`}
                                    loading='lazy'
                                />
                            ))
                        ) : (
                            ""
                        )}
                    </div>




                    {/* 
                    <div className='photo-grid' data-aos='fade-up' >

                        {avatarsList ? avatarsList.map((photo, index) => (
                            <img key={index} onClick={() => handleRedirect(photo, "talking_photo")}
                                src={photo.preview_image_url} />

                        )) : ""}




                    </div> */}




                </div>
            </div>
        </>
    )
}
